import { SkillCategory } from "../types";

// EDIT ME: add/remove/rename categories and skills freely - the Skills
// section just maps over this array.
export const skillCategories: SkillCategory[] = [
  {
    title: "Engine & Language",
    skills: ["Unity", "C#"],
  },
  {
    title: "Multiplayer",
    skills: ["Multiplayer Networking", "Mirror Networking"],
  },
  {
    title: "Gameplay & AI",
    skills: ["Gameplay Programming", "AI Systems"],
  },
  {
    title: "Design & Workflow",
    skills: ["Game Design", "Prototyping", "UI Implementation", "Git & GitHub"],
  },
];
